import { noteSorter } from '../helpers/noteUtils'
import { ControlSheetNote } from '../types/types'
import styles from './ControlSheetNotesViewer.module.scss'
import ChatIcon from '../assets/chat.svg'
import { ControlSheetNoteView } from './ControlSheetNoteView'

interface Props {
    notes: ControlSheetNote[]
}

export const ControlSheetNotesViewer = ({ notes }: Props) => {
    const allNotes = [...(notes || [])].sort(noteSorter).reverse()

    return allNotes.length > 0 ? (
        <div className={styles.notesContainer}>
            {allNotes.map((note) => (
                <div className={styles.note} key={note.id}>
                    <div className={styles.chatIcon}>
                        <ChatIcon />
                    </div>
                    <ControlSheetNoteView note={note} />
                </div>
            ))}
        </div>
    ) : (
        <></>
    )
}
